import React from 'react';
import './Differentiator.css';

const Differentiator = () => {
  return (
    <section className="differentiator">
      <div className="differentiator-container reveal">
        <span className="differentiator-eyebrow">Why we built Dangol</span>
        <blockquote className="differentiator-quote display-italic">
          <span className="quote-mark" aria-hidden="true">“</span>
          We built your shop its own app.<br />
          Recognition, connection, insight.<br />
          <span className="quote-emph">All in one. Built for your regulars.</span>
        </blockquote>
      </div>
    </section>
  );
};

export default Differentiator;
